// helpers
import {TFunction} from 'i18next';
import {checkHasFeatureAccess} from '../../../shared/helpers';

// styles
import {IconArticles, IconContact, IconProfile} from '../DashboardPage-styles';

// types
import {UserConfig} from '../../../shared/services/ApiService/types/endpoints';

/**
 * Get the quick links for the dashboard based on user configuration
 * @param userConfig
 */
export const getQuickLinks = (
  userConfig: UserConfig | null,
  t: TFunction<'translation', undefined>,
) => {
  const quickLinks = [];

  if (checkHasFeatureAccess(userConfig, 'contentLibrary')) {
    quickLinks.push({
      Icon: IconArticles,
      title_key: t('dashboard_contentLibrary_title'),
      description_key: t('dashboard_contentLibrary_description'),
      href: '/articles',
    });
  }

  quickLinks.push(
    {
      Icon: IconProfile,
      title_key: t('dashboard_profile_title'),
      description_key: t('dashboard_profile_description'),
      href: '/profile',
    },
    {
      Icon: IconContact,
      title_key: t('dashboard_contact_title'),
      description_key: t('dashboard_contact_description'),
      href: '/contact',
    },
  );

  return quickLinks;
};
